import {Component, Input} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {Subject} from "rxjs";

@Component({
  selector: 'app-org-remove-user-modal',
  templateUrl: './org-remove-user-modal.component.pug',
  styleUrls: ['./org-remove-user-modal.component.scss'],
  standalone: false
})
export class OrgRemoveUserModalComponent {
  REMOVE_LABEL = $localize`Remove`
  @Input() hasPermission = false;
  headerText = ""
  showCloseButton = false
  reinstatementText = "";
  confirmationText = "";
  noPermissionText = "";
  cancelButtonLabel = $localize`Cancel`;
  removeButtonLabel = $localize`Remove`;
  selection = new Subject<boolean>();

  constructor(public bsModalRef: BsModalRef, ) {
  }

  removeUser() {
    this.bsModalRef?.hide();
    this.selection.next(true);
  }

}
